module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/~/axios/index.js
// module id = 1860
// module chunks = 0